import * as actionTypes from "../Actions/actionTypes";

const initialState = {
  originalPage: "",
  currentMemberId: "",
};

export const BranchReducer = (state = initialState, action) => {
  switch (action.types) {
    case actionTypes.UPDATE_BRANCH_REDUCER:
      return {
        ...state,
        ...action.data,
      };

    default:
      return state;
  }
};
export default BranchReducer;
